
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import Vue from 'vue';
import { sync } from 'vuex-router-sync'

import initHelpers from '72cms-ui/helpers';
import MainComponent from '72cms-ui/components/MainComponent';

import createStore from './store';
import router from './router';

import env from './config/base';
import config from './config';
import utils from './utils';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const getHelpers = initHelpers(env);
const helpers = getHelpers();

// set router instance
helpers.setRouter(router);

// set config
helpers.setConfig(config);

// set custom helpers
_.toPairs(utils).forEach(([name, method]) => helpers.setHelper(name, method));

createStore(helpers).then((store) => {
    const unsync = sync(store, router)

    const app = new Vue({
        el: '#app',
        store,
        router,
        render: h => h(MainComponent, {
            props: { getHelpers }
        }),
    });
})



// WEBPACK FOOTER //
// ./resources/assets/cms/js/app.js